import { render } from "./user-list-form.vue?vue&type=template&id=24305e2d"
import script from "./user-list-form.vue?vue&type=script&lang=js"
export * from "./user-list-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__